import { Component, OnInit } from '@angular/core';
import 'rxjs/add/operator/finally';
import { ActiveModal, ModalService } from '../../../modals';
import { WidgetFactoryService } from '../../services/widget-factory.service';
import { Buttons } from '../../../modals/classes/buttons';
import { WidgetInterface } from '../../';
import { AuthenticationService } from '../../../authentication/services/authentication.service';
import { UserModel } from '../../../authentication/models/user.model';

@Component({
    selector: 'chassis-core-dashboards-add-widget-modal',
    templateUrl: 'widget-list.modal.html',
    styleUrls: ['widget-list.modal.scss']
})
export class WidgetListModal implements OnInit {

    /**
     * The Loading instance.
     *
     * @type {any}
     */
    public loading: boolean = false;

    public widgets = [];

    constructor(protected modal: ActiveModal, protected widgetFactoryService: WidgetFactoryService, protected modalService: ModalService, protected authenticationService: AuthenticationService) {
    }

    ngOnInit() {
        this.setSelectableWidgets();

        const buttons = this.modal.get<Buttons>('buttons');
        buttons.remove('ok');
    }

    protected setSelectableWidgets() {
        const widgets = this.widgetFactoryService.all();

        const user = this.authenticationService.user();

        user.subscribe((user: UserModel) => {
            this.widgets = widgets.filter((widget: WidgetInterface) => {
                return this.userHasPermissionsForWidget(user, widget);
            });
        });
    }

    protected userHasPermissionsForWidget(user: UserModel, widget: WidgetInterface): boolean {
        if (!widget.permissions || !widget.permissions.length) {
            return true;
        }

        const permissions = widget.permissions;

        for (const permission of permissions) {
            if (!user.can(permission)) {
                return false;
            }
        }

        return true;
    }

    public add(value) {
        this.loading = true;

        this.modal.close(value);
    }

    // protected openAddWidgetModal() {
    //     const modal = this.modalService.open(AddWidgetModal, {}, {
    //         classes: 'slide-top'
    //     });
    //
    //     modal.closed((value) => {
    //         console.log('add ', value);
    //
    //         this.modal.close(value);
    //     });
    // }

}


// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/dashboards/modals/widget-list-modal/widget-list.modal.ts